import { init } from '@makemydeal/dr-activities-fuel-saving';
import { additionalSelectors } from './additionalSelectors';

export const configureFuelSaving = () => init(additionalSelectors);
